export default __webpack_public_path__ + "static/media/m-fsk-08.9b2e3f91.jpg";